import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { dataDefault } from 'Views/Admin/CollectionPointBagRequests/BagRequests'
import { apiCollectionPointBagRequestsList, apiCollectionPointBagRequestsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/collectionPointBagRequests/getData', async datas => {
    const { data } = await apiCollectionPointBagRequestsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/collectionPointBagRequests/getView', async id => {
    if (!id) return viewData
    const { data } = await apiCollectionPointBagRequestsView(id)
    data.material_types = data.material_types && data.material_types.length !== 0 ? data.material_types : [dataDefault]
    return data
})

const viewData = {
    collection_point_id: '',
    material_types: [dataDefault],
}

export const collectionPointBagRequestsSlice = createSlice({
    name: 'admin/collectionPointBagRequests',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = collectionPointBagRequestsSlice.actions

export default collectionPointBagRequestsSlice.reducer
